import React from "react";

const EnrollModal = ({ handleAddOpen }) => {
  return (
    <div className="fixed right-4 bottom-4 sm:bottom-6 hidden sm:block">
      <div className="bg-[#064585] text-white rounded-full shadow-xl shadow-[#064585]/40 px-4 py-2.5 flex items-center gap-3 border border-white/10 backdrop-blur-md">
        <p className="text-xs sm:text-sm text-slate-100">
          Ready to start your journey?
        </p>
        <button
          className="ml-2 bg-white text-[#064585] px-3 py-1.5 rounded-full text-xs sm:text-sm font-semibold hover:bg-slate-100 transition-all duration-200 hover:-translate-y-0.5"
          onClick={handleAddOpen}
        >
          Enroll
        </button>
      </div>
    </div>
  );
};

export default EnrollModal;
